import CustomRouterController from './custom-router.controller';
import { CustomRouterProps } from './custom-router.model';

const CustomRouter = (props: CustomRouterProps) => {
  return <CustomRouterController {...props} />;
};

export default CustomRouter;
